import Component from '../core/Component'

export default class MobileNavOpener extends Component {

    prepare() {
        this.element.addEventListener('click', this.handleClick)
    }

    handleClick(event) {
        event.preventDefault()

        const nav = Component.getFromElement('mobile-nav')

        if (nav) {
            nav.toggle()
        }
    }
}